import {
    ICustoEncarregado,
    ICustoEncarregadoResponse,
    IListagemDeCustosEncarregadoRequest,
} from "../../../Interfaces/AssistenciaTecnica/CustoEncarregadoRelatorioBI/CustoEncarregadoRelatorioBIInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function CadastroDeCustoEncarregadoService(
    requestBody: ICustoEncarregado
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/custos/cadastrodecustoencarregado`,
            requestBody
        )
    );
}

export async function getCustoEncarregadoService(ID_CUSTO: number) {
    return Service(
        Axios.get<ICustoEncarregado>(
            `/assistenciatecnica/custos/getcustoencarregado?ID_CUSTO=${ID_CUSTO}`
        )
    );
}

export async function ListagemDeCustoEncarregadoService(
    requestBody: IListagemDeCustosEncarregadoRequest
) {
    return Service(
        Axios.post<ICustoEncarregadoResponse>(
            `/assistenciatecnica/custos/listagemdecustosencarregados`,
            requestBody
        )
    );
}

export async function AtualizacaoDeCustoEncarregadoService(
    requestBody: Array<ICustoEncarregado>
) {
    return Service(
        Axios.patch(
            `/assistenciatecnica/custos/atualizacaodecustoencarregado`,
            requestBody
        )
    );
}

export async function RemocaoDeCustoEncarregadoService(ID: number) {
    return Service(
        Axios.delete(
            `/assistenciatecnica/custos/remocaodecustoencarregado?ID=${ID}`
        )
    );
}
